import { useEffect, useState } from "react";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PageHeader, Panel, useAdminSettings } from "@/pages/admin/shared";
import { DangerZone } from "@/pages/admin/DangerZone";

const CHANNELS = [
  ["mock", "Demo (code shown on screen)"],
  ["email", "Email (Resend)"],
  ["sms", "SMS (Twilio)"],
];

const ToggleRow = ({ title, desc, checked, onChange, testId }) => (
  <div className="flex items-start gap-4 border-b border-gold/20 py-4 last:border-0">
    <div className="flex-1">
      <p className="font-semibold">{title}</p>
      <p className="text-xs text-ink-muted">{desc}</p>
    </div>
    <Switch checked={checked} onCheckedChange={onChange} data-testid={testId} />
  </div>
);

export default function SettingsPage() {
  const { settings: s, save } = useAdminSettings();
  const [limit, setLimit] = useState("");
  useEffect(() => { if (s) setLimit(String(s.rate_limit_per_hour)); }, [s]);
  if (!s) return null;

  return (
    <div data-testid="admin-settings">
      <PageHeader title="Settings" sub="Integrity and visibility controls" />
      <div className="grid gap-4 lg:grid-cols-2">
        <Panel>
          <ToggleRow title="Voting open" desc="When off, the public site shows “Voting is closed”." checked={s.voting_open} onChange={(v) => save({ voting_open: v })} testId="settings-voting-open" />
          <ToggleRow title="Public leaderboard" desc="Show live rankings at /leaderboard." checked={s.leaderboard_public} onChange={(v) => save({ leaderboard_public: v })} testId="settings-leaderboard-public" />
          <ToggleRow title="Require OTP before voting" desc="Voters confirm an email or phone code; one vote per category per verified contact." checked={s.otp_required} onChange={(v) => save({ otp_required: v })} testId="settings-otp-required" />
        </Panel>
        <Panel>
          <p className="font-semibold">OTP channel</p>
          <Select value={s.otp_channel} onValueChange={(v) => save({ otp_channel: v }, "OTP channel updated")}>
            <SelectTrigger className="mt-2 bg-ivory" data-testid="settings-otp-channel"><SelectValue /></SelectTrigger>
            <SelectContent>
              {CHANNELS.map(([v, l]) => (
                <SelectItem key={v} value={v} disabled={!s.channels[v]} data-testid={`settings-otp-channel-${v}`}>
                  {l}{!s.channels[v] ? " — not configured" : ""}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <p className="mt-2 text-xs text-ink-muted">SMS needs TWILIO_ACCOUNT_SID, TWILIO_AUTH_TOKEN and TWILIO_VERIFY_SERVICE on the server.</p>

          <p className="mt-6 font-semibold">Submissions per IP per hour</p>
          <div className="mt-2 flex gap-2">
            <input type="number" min={1} value={limit} onChange={(e) => setLimit(e.target.value)} data-testid="settings-rate-limit-input" className="h-10 w-28 rounded-lg border border-gold/40 bg-ivory px-3 outline-none focus:border-gold" />
            <button type="button" onClick={() => save({ rate_limit_per_hour: Number(limit) })} disabled={!Number(limit)} data-testid="settings-rate-limit-save" className="rounded-full bg-forest px-4 text-sm font-semibold text-white disabled:opacity-40">Save</button>
          </div>
          <p className="mt-2 text-xs text-ink-muted">Venue Wi-Fi puts many phones behind one IP — raise this if visitors report being blocked.</p>
        </Panel>
      </div>
      <DangerZone />
    </div>
  );
}
